const pro = {
	path: '/pro',
	component: ()=>import("@/views/main.vue"),
	meta:{
		title:"服务商管理后台",
		requiresAuth:false
	},
	children:[
		{
			path: 'Home',
			component: ()=>import("@/views/pro/home.vue"),
			meta:{
				title:"首页",
				requiresAuth:false
			},
		},
		{
			path: 'User',
			component: ()=>import("@/views/pro/user.vue"),
			meta:{
				title:"员工管理",
				requiresAuth:false
			},
		},
		{
			path: 'Role',
			component: ()=>import("@/views/pro/role.vue"),
			meta:{
				title:"角色管理",
				requiresAuth:false
			},
		},
		{
			path: 'OrderDkzx',
			component: ()=>import("@/views/pro/OrderDkzx.vue"),
			meta:{
				title:"订单信息",
				requiresAuth:false
			},
		},
		{
			path: 'Merchant',
			component: ()=>import("@/views/pro/Merchant.vue"),
			meta:{
				title:"商户信息",
				requiresAuth:false
			},
		},
		{
			path: 'ShopList',
			component: ()=>import("@/views/pro/shopList.vue"),
			meta:{
				title:"商品列表",
				requiresAuth:false
			},
		},
		
		{
			path: 'Store',
			component: ()=>import("@/views/pro/Store.vue"),
			meta:{
				title:"门店信息",
				requiresAuth:false
			},
		},
		{
			path: 'ShopReport',
			component: ()=>import("@/views/pro/ShopReport.vue"),
			meta:{
				title:"商品日报表",
				requiresAuth:false
			},
		},
		{
			path: 'dayReport',
			component: ()=>import("@/views/pro/dayReport.vue"),
			meta:{
				title:"订单日报表",
				requiresAuth:false
			},
		},
		{
			path: 'PostWay',
			component: ()=>import("@/views/pro/PostWay.vue"),
			meta:{
				title:"发货方式",
				requiresAuth:false
			},
		},
		{
			path: 'Addr',
			component: ()=>import("@/views/pro/Addr.vue"),
			meta:{
				title:"地址管理",
				requiresAuth:false
			},
		},
		{
			path: 'ShareCode',
			component: ()=>import("@/views/pro/ShareCode.vue"),
			meta:{
				title:"推广码",
				requiresAuth:false
			},
		},
		{
			path: 'Invoice',
			component: ()=>import("@/views/pro/Invoice.vue"),
			meta:{
				title:"收货单管理",
				requiresAuth:false
			},
		},
		{
			path: 'Poster',
			component: ()=>import("@/views/pro/Poster.vue"),
			meta:{
				title:"配送员管理",
				requiresAuth:false
			},
		},
		{
			path: 'warehouse',
			component: ()=>import("@/views/pro/warehouse/Index.vue"),
			meta:{
				title:"仓库管理",
				requiresAuth:false
			},
			children:[
				{
					path: 'Item/:ware_id',
					component: ()=>import("@/views/pro/warehouse/Item.vue"),
					meta:{
						title:"区域管理",
						requiresAuth:false
					},
				},
				{
					path: 'Branch/:ware_id',
					component: ()=>import("@/views/pro/warehouse/Branch.vue"),
					meta:{
						title:"支线管理",
						requiresAuth:false
					},
				},
				{
					path: 'Tranfer/:ware_id',
					component: ()=>import("@/views/pro/warehouse/Tranfer.vue"),
					meta:{
						title:"运输管理",
						requiresAuth:false
					},
				},
				{
					path: 'Invoice/:ware_id',
					component: ()=>import("@/views/pro/warehouse/Invoice.vue"),
					meta:{
						title:"收货单管理",
						requiresAuth:false
					},
				},
				{
					path: 'Info/:ware_id',
					component: ()=>import("@/views/pro/warehouse/Info.vue"),
					meta:{
						title:"仓库信息",
						requiresAuth:false
					},
				},
			]
		},
		{
			path: 'Ware',
			component: ()=>import("@/views/pro/Ware.vue"),
			meta:{
				title:"仓库管理",
				requiresAuth:false
			},
		},

	]

}

export default pro